<template>
  <organizations-index
    :fields="fields"
    :filters="filters"
    :query="query"
  />
</template>

<script>
import Vue from 'vue';
import Organization from '~/models/Organization';
import OrganizationsIndex from '~/pages/shared/organizations/OrganizationsIndex';

export default Vue.extend({
  components: { OrganizationsIndex },

  middleware: 'admin',

  data: () => ({
    query: () => new Organization().include('tenant'),

    filters: ['search', 'tenant_id', 'usage_type', 'confirmed'],

    fields: ['name', 'tenant.name', 'usage_type', 'address.city', 'created_at', 'actions'],
  }),
});
</script>
